import { Doughnut } from "react-chartjs-2";
import classes from "./AttributionBox.module.css";

export default function AttributionBox({ data }) {
  if (data == null || data == undefined) return <></>;  
  let data1 = data.attributionData;
  console.log(data1);
  let labelArr = data1.options;

  let responseArr = data1.attribution;

  return (
    <>
      <div className={classes.container}>
        <p>Attribution Analysis (New Customers)</p>
        <div className={classes.content}>
          {labelArr.map((item, index) => {
            return (
              <p key={`2${index}`}>
                {`-`} {item} -{" "}
                <span className={classes.numbers}>{responseArr[index]}%</span>
              </p>
            );
          })}
        </div>
      </div>
    </>
  );
}
